export const CREATION_FORCES = [
  {
    number: 0,
    title: "De ultieme spiegel",
    negatief: "omspiegelen",
    positief: "doorkaatsen",
    negatiefUitleg: "Neemt op en geeft terug met ruimte; zacht en omarmend.",
    positiefUitleg:
      "Laat zien wat er werkelijk is, zonder vervorming; scherp en ontmaskerend.",
  },
  {
    number: 1,
    title: "Hartsverlangen",
    theme: "Verlangen",
    archetype: "De Zoeker",
    coreSentence: "Ik voel dat er meer mogelijk is.",
    negatief: "zonder bezieling",
    positief: "opgaan in anderen",
  },
  {
    number: 2,
    title: "Verbinding",
    theme: "Verbinding",
    archetype: "De Verbinder",
    coreSentence: "Ik breng mensen, werelden en gevoelens samen.",
    negatief: "uit contact",
    positief: "in verbinding",
  },
  {
    number: 3,
    title: "Communicatie",
    theme: "Uitwisseling",
    archetype: "De Boodschapper",
    coreSentence: "Ik deel, beweeg en breng iets op gang.",
    negatief: "niet praten, wegkruipen",
    positief: "veel praten, zonder inhoud",
  },
  {
    number: 4,
    title: "Creativiteit & balans",
    theme: "Vorm",
    archetype: "De Kunstenaar",
    coreSentence: "Ik geef structuur aan wat wil ontstaan.",
    negatief: "structuur",
    positief: "chaos",
  },
  {
    number: 5,
    title: "Bouwen & spelen",
    theme: "Ondernemen",
    archetype: "De Ondernemer / Bouwer",
    coreSentence: "Ik zet energie om in actie.",
    negatief: "passief",
    positief: "actief",
  },
  {
    number: 6,
    title: "Helderheid & begrip",
    theme: "Inzicht",
    archetype: "De Ziener",
    coreSentence: "Ik doorzie patronen en breng helderheid.",
    negatief: "medium",
    positief: "professor",
  },
  {
    number: 7,
    title: "Levensenergie",
    theme: "Energie",
    archetype: "De Vuurdrager",
    coreSentence: "Ik activeer, beziel en breng levenskracht.",
    negatief: "ingehouden verdriet",
    positief: "magisch",
  },
  {
    number: 8,
    title: "Kloppend maken",
    theme: "Heling",
    archetype: "De Heelmeester",
    coreSentence: "Ik herstel, verzacht en breng balans.",
    negatief: "lijmen",
    positief: "kapot maken",
  },
  {
    number: 9,
    title: "Dienstbaarheid",
    theme: "Bijdrage",
    archetype: "De Dienaar van het Grotere",
    coreSentence: "Ik geef mijn talent aan iets dat groter is dan ik.",
    negatief: "pleaser",
    positief: "egoïst",
  },
  {
    number: 10,
    title: "Leiderschap",
    theme: "Verantwoordelijkheid",
    archetype: "De Hoeder",
    coreSentence: "Ik draag, bescherm en neem mijn plek in.",
    negatief: "machteloos",
    positief: "bij machte",
  },
  {
    number: 11,
    title: "Meesterschap",
    theme: "Wijsheid",
    archetype: "De Wijze",
    coreSentence: "Ik verbind ervaring met diep weten.",
    negatief: "leerling",
    positief: "leraar",
  },
  {
    number: 12,
    title: "Afronding",
    theme: "Afronding",
    archetype: "De Voltooier",
    coreSentence: "Ik rond af, integreer en maak ruimte voor nieuw begin.",
    negatief: "niet aan beginnen",
    positief: "afraffelen",
  },
];

export function creationForceFor(number) {
  return CREATION_FORCES[Number(number)] || null;
}

export function archetypeContentFor(number, numberTheme = null) {
  const creationForce = creationForceFor(number);

  return {
    theme: numberTheme?.archetype_theme || creationForce?.theme || "",
    archetype: numberTheme?.archetype || creationForce?.archetype || "",
    coreSentence:
      numberTheme?.archetype_core_sentence || creationForce?.coreSentence || "",
  };
}

export function expressionSummariesFor(number, numberTheme = null) {
  const creationForce = creationForceFor(number);

  return {
    female:
      numberTheme?.female_expression_short || creationForce?.negatief || "",
    male: numberTheme?.male_expression_short || creationForce?.positief || "",
    femaleDescription:
      numberTheme?.female_expression_description ||
      creationForce?.negatiefUitleg ||
      "",
    maleDescription:
      numberTheme?.male_expression_description ||
      creationForce?.positiefUitleg ||
      "",
  };
}
